<!-- <main class="image-backg" style="background-image: url('assets/images/backg.png');"> -->
  <main class="image-backg">
  <div>
    <div class="page-loader">
      <div class="loader">Loading...</div>
    </div>
    <div class="hidden-sm hidden-md hidden-lg">
      <div  class="text-center col-lg-3 col-md-4 col-sm-4 col-xs-12 vertical-bar">
        <div class="col-xs-3">
            <img class='padd1 sizeimg' src="assets/images/elespectador/logo/logodj.png"  alt="Portfolio Item"/>
        </div>
        <div class="col-xs-9">
          <div class="text-center">
            <div class="ladilla col-xs-6 col-sm-6 col-md-6 col-lg-6">
              <div class="alt-features-item ">
                    <a target="_blank" class="btn btn-sm color-dream-btn" href="https://dreamjobs.com.co/DJ/empresa">Solicito personal</a>
              </div>
            </div>
            <div class="ladilla col-xs-6 col-sm-6 col-md-6 col-lg-6 pb">
              <div class="alt-features-item">
                    <a target="_blank" class="btn btn-sm color-dream-btn" href="https://empresa.dreamjobs.com.co/landing/elespectador">Busco Empleo</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-9 col-md-8 col-sm-8 col-xs-12 vertical-bar2">
        <!-- <h4 class="font-alt mb-0">Tabs</h4>
        <hr class="divider-w mt-10 mb-20"> -->
        <div role="tabpanel">
          <ul class="nav nav-tabs font-alt" role="tablist">
            <li class="active"><a class="color-dream" href="#all" data-toggle="tab">Empleos</a></li>
            <li><a href="#urgent" class="color-dream" data-toggle="tab">Urgentes</a></li>
            <li><a href="#companies" class="color-dream" data-toggle="tab">Empresas</a></li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane active" id="all">
                <div *ngFor="let jobAll of jobsAll; let i = index"  class="col-xs-6 col-sm-4 col-md-4 col-lg-4 jobpaddingbtom">
                  <div class="alt-features-item">
                        <a target="_blank" class="color-dream" href="https://empresa.dreamjobs.com.co/landing/elespectador"><h5 class="font-alt  ellipsis">{{jobAll.title}}</h5></a>
                        <div [ngClass]="{'widgetdj':true}">
                            <ul [ngClass]="{'icon-list':true}">
                            <li> <a target="_blank" style class="color-dream"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><h6 class="font-alt ellipsis">Ver Empleo</h6></a> </li>
                            <li class="hidden-xs"> <h6 class="ellipsis hidden-xs"><strong>Empresa:</strong> </h6><h6 class="ellipsis">  {{jobAll.company.name}}</h6></li>
                            <li class="hidden-xs"><h6 class="ellipsis "><strong>Area Laboral:</strong></h6><h6 class="ellipsis">  {{jobAll.jc}}</h6> </li>
                            <li> <a target="_blank" style class="color-dream"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img class="imgnowlittle" src="{{'assets/images/elespectador/'+i+'.png'}}" alt="Portfolio Item"/></a> </li>
                            </ul>
                        </div>
                  </div>
                </div>
            </div>
            <div class="tab-pane" id="urgent">
                  <div *ngFor="let jobUrgent of jobsUrgent; let i = index"  class="col-xs-6 col-sm-4 col-md-4 col-lg-4 jobpaddingbtom">
                  <div class="alt-features-item">

                        <a target="_blank" style class="color-dream"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><h5 class="font-alt ellipsis">{{jobUrgent.title}}</h5></a>

                        <div [ngClass]="{'widgetdj':true}">
                            <ul [ngClass]="{'icon-list':false}">
                            <li> <a target="_blank" style class="color-dream"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><h6 class="font-alt ellipsis">Ver Empleo</h6></a> </li>
                            <li class="hidden-xs"> <h6 class="ellipsis hidden-xs"><strong>Empresa:</strong></h6>
                                 <h6 class="ellipsis">{{jobUrgent.company.name}}</h6></li>
                            <li class="hidden-xs" ><h6 class="ellipsis hidden-xs"><strong>Area Laboral:</strong></h6>
                                <h6 class="ellipsis">{{jobUrgent.jc}}</h6> </li>
                                <li> <a target="_blank" style class="color-dream"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img class="imgnowlittle" src="{{'assets/images/elespectador/'+i+'1.png'}}" alt="Portfolio Item"/></a> </li>
                            </ul>
                        </div>
                  </div>
                </div>
            </div>
            <div class="tab-pane" id="companies">
                <a target="_blank"  class="text-center color-dream image1"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img src="{{'assets/images/responsive-small.png'}}" alt="Portfolio Item"/></a>
                <a target="_blank"  class="text-center color-dream image2"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img src="{{'assets/images/responsive-small2.png'}}" alt="Portfolio Item"/></a>
                <a target="_blank"  class="text-center color-dream image3"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img src="{{'assets/images/responsive-small3.png'}}" alt="Portfolio Item"/></a>
                <a target="_blank"  class="text-center color-dream image4"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img src="{{'assets/images/responsive-small4.png'}}" alt="Portfolio Item"/></a>
                <a target="_blank"  class="text-center color-dream image5"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img src="{{'assets/images/responsive-small5.png'}}" alt="Portfolio Item"/></a>
                <div class="row"><a target="_blank" class="color-dream"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><h6 class="text-center ellipsis"><b>ver 36432 vacantes</b></h6></a></div>

                    <!-- <div *ngFor="let jobCompany of jobsCompanySlice"  class="top-pad col-xs-4 col-sm-4 col-md-4 col-lg-4 jobpaddingbtom">
                        <div class="alt-features-item">
                            <div class="alt-features-icon"><span><a target="_blank" style class="color-dream"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img [src]="jobCompany.logo" alt=""></a></span></div>
                             <a target="_blank" class="color-dream" href="https://empresa.dreamjobs.com.co/landing/elespectador"><h5 class="font-alt  ellipsis">{{jobCompany.company}}</h5></a>

                        </div>

                  </div> -->
            </div>
          </div>
        </div>


      </div>
      </div>
            <div class="hidden-xs">
              <div  class="text-center col-lg-3 col-md-4 col-sm-4 col-xs-4 vertical-bar">
                <img class='padd1 sizeimg' src="assets/images/elespectador/logo/logodj.png"  alt="Portfolio Item"/>
                <h4 class="padd hidden-xs"> Encuentra el empleo de tus sueños más cerca</h4>

                <div class="hidden-xs">
                  <div class="text-center">
                    <div class="ladilla col-xs-12 col-sm-12 col-md-6 col-lg-6">
                      <div class="alt-features-item buttn-wrap">
                            <a target="_blank" class="btn btn-sm color-dream-btn" href="https://dreamjobs.com.co/DJ/empresa">Solicito personal</a>
                      </div>
                    </div>
                    <div class="ladilla col-xs-12 col-sm-12 col-md-6 col-lg-6 pb">
                      <div class="alt-features-item buttn-wrap">
                            <a target="_blank" class="btn btn-sm color-dream-btn" href="https://empresa.dreamjobs.com.co/landing/elespectador">Busco Empleo</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-9 col-md-8 col-sm-8 col-xs-8 vertical-bar2">
                <!-- <h4 class="font-alt mb-0">Tabs</h4>
                <hr class="divider-w mt-10 mb-20"> -->
                <div role="tabpanel">
                  <ul class="nav nav-tabs font-alt" role="tablist">
                    <li class="active"><a class="color-dream" href="#all2" data-toggle="tab">Empleos</a></li>
                    <li><a href="#urgent2" class="color-dream" data-toggle="tab">Urgentes</a></li>
                    <li><a href="#companies2" class="color-dream" data-toggle="tab">Empresas</a></li>
                  </ul>
                  <div class="tab-content">
                    <div class="tab-pane active" id="all2">
                        <div *ngFor="let jobAll of jobsAll; let i = index"  class="col-xs-6 col-sm-4 col-md-4 col-lg-4 jobpaddingbtom">
                          <div class="alt-features-item">
                                <a target="_blank" class="color-dream" href="https://empresa.dreamjobs.com.co/landing/elespectador"><h5 class="font-alt  ellipsis">{{jobAll.title}}</h5></a>
                                <div [ngClass]="{'widgetdj':true}">
                                    <ul [ngClass]="{'icon-list':true}">
                                    <li> <h6 class="ellipsis"><strong>Empresa:</strong>  {{jobAll.company.name}}</h6></li>
                                    <li><h6 class="ellipsis"><strong>Area Laboral:</strong>  {{jobAll.jc}}</h6> </li>
                                    <li><img src="{{'assets/images/elespectador/'+i+'.png'}}" alt="Portfolio Item"/> </li>
                                    </ul>
                                </div>
                          </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="urgent2">
                          <div *ngFor="let jobUrgent of jobsUrgent; let i = index"  class="col-xs-6 col-sm-4 col-md-4 col-lg-4 jobpaddingbtom">
                          <div class="alt-features-item">

                                <a target="_blank" style class="color-dream"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><h5 class="font-alt ellipsis">{{jobUrgent.title}}</h5></a>

                                <div [ngClass]="{'widgetdj':true}">
                                    <ul [ngClass]="{'icon-list':false}">
                                    <li> <h6 class="ellipsis"><strong>Empresa:</strong>{{jobUrgent.company.name}}</h6></li>
                                    <li><h6 class="ellipsis"><strong>Area Laboral:</strong>{{jobUrgent.jc}}</h6> </li>
                                    <li><img class='' src="{{'assets/images/elespectador/'+i+'1.png'}}" alt="Portfolio Item"/> </li>
                                    </ul>
                                </div>
                          </div>
                        </div>
                    </div>
                    <div class="tab-pane" id="companies2">
                        <a target="_blank"  class="text-center color-dream image6"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img src="{{'assets/images/responsive-small.png'}}" alt="Portfolio Item"/></a>
                        <a target="_blank"  class="text-center color-dream image7"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img src="{{'assets/images/responsive-small2.png'}}" alt="Portfolio Item"/></a>
                        <a target="_blank"  class="text-center color-dream image8"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img src="{{'assets/images/responsive-small3.png'}}" alt="Portfolio Item"/></a>
                        <a target="_blank"  class="text-center color-dream image9"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img src="{{'assets/images/responsive-small4.png'}}" alt="Portfolio Item"/></a>
                        <a target="_blank"  class="text-center color-dream image10"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img src="{{'assets/images/responsive-small5.png'}}" alt="Portfolio Item"/></a>
                        <div class="row"><a target="_blank" class="color-dream"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><h6 class="text-center ellipsis"><b>ver 36432 vacantes</b></h6></a></div>
                              <!-- <div *ngFor="let jobCompany of jobsCompanySlice"  class="top-pad col-xs-6 col-sm-4 col-md-4 col-lg-4 jobpaddingbtom">
                                <div class="alt-features-item">
                                    <div class="alt-features-icon"><span><a target="_blank" style class="color-dream"  href="https://empresa.dreamjobs.com.co/landing/elespectador"><img [src]="jobCompany.logo" alt=""></a></span></div>
                                     <a target="_blank" class="color-dream" href="https://empresa.dreamjobs.com.co/landing/elespectador"><h5 class="font-alt  ellipsis">{{jobCompany.company}}</h5></a>
                                      <div [ngClass]="{'widgetdj':true}">
                                         <ul [ngClass]="{'icon-list':true}">
                                          <li> <h5 class="font-alt  ellipsis">{{jobCompany.jobs_count}} <strong>Ofertas</strong>  </h5></li>
                                         </ul>
                                      </div>
                                </div>

                          </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
              </div>
  </main>



// WEBPACK FOOTER //
// ./src/app/offers-micro-sites/offers-micro-sites.component.html